<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation
  class="bg-card print:hidden z-[1400]"
  [appearance]="navigationAppearance"
  [mode]="isScreenSmall ? 'over' : 'side'"
  [name]="'mainNavigation'"
  [navigation]="navigation.default"
  [opened]="isScreenSmall ? navOpened : true"
  [transparentOverlay]="isScreenSmall"
  (openedChanged)="navOpened = $event"
>
  <!-- Navigation header hook -->
  <ng-container fuseVerticalNavigationContentHeader>
    <!-- Logo -->

    <div
      class="mt-10 mb-20 flex h-20 items-center justify-center px-6 py-[10px]"
    >
      <ng-lottie
        [styles]="style"
        [options]="options"
        style="display: contents"
      />
    </div>
    <!-- Navigation appearance toggle button -->
    <div class="flex h-20 items-center pl-9">
      <button
        class="hidden md:inline-flex"
        mat-icon-button
        (click)="toggleNavigationAppearance()"
      >
        <mat-icon
          [svgIcon]="'custom_icon:arrows-up-down'"
          style="transform: rotate(90deg)"
        ></mat-icon>
      </button>
    </div>
  </ng-container>
</fuse-vertical-navigation>
<!-- Wrapper -->
<div class="flex w-full min-w-0 flex-auto flex-col">
  <div
    [ngClass]="getPaddingClass()"
    class="topnav-sticky-shell print:hidden"
    [class.topnav-sticky-shell--visible]="isTopNavVisible"
    [class.topnav-sticky-shell--hidden]="!isTopNavVisible"
    (mouseenter)="onTopNavMouseEnter()"
    (mouseleave)="onTopNavMouseLeave()"
  >
    <nav class="topnav-bar" aria-label="Top navigation">
      <div class="topnav-left-group">
        <button
          class="topnav-icon-button"
          mat-icon-button
          (click)="toggleNavigation('mainNavigation')"
          aria-label="Toggle menu"
        >
          <mat-icon
            class="mat-icon-white"
            [svgIcon]="'heroicons_outline:bars-3'"
          ></mat-icon>
        </button>
      </div>

      <div class="topnav-right-group">
        <div class="topnav-action-slot">
          <languages></languages>
        </div>
        <div class="topnav-action-slot hidden md:flex">
          <fuse-fullscreen></fuse-fullscreen>
        </div>
        <div class="topnav-action-slot">
          <user
            [showAvatar]="false"
            [anonymousMode]="isAnonymousBatteryPass"
          ></user>
        </div>
      </div>
    </nav>
  </div>

  <div
    [ngClass]="getPaddingClass()"
    class="topnav-hover-zone print:hidden"
    [class.topnav-hover-zone--active]="!isTopNavVisible"
    (mouseenter)="onTopHoverZoneEnter()"
  ></div>

  <div
    [ngClass]="getPaddingClass()"
    class="topnav-gradient-mask print:hidden"
    [class.topnav-gradient-mask--hidden]="!isTopNavVisible"
  ></div>

  <div
    class="flex flex-auto flex-col pt-10 topnav-content-area"
    [ngClass]="getPaddingClass()"
    id="content-area"
  >
    <p-breadcrumb
      [model]="breadcrumbService.menuItems"
      [home]="breadcrumbService.home"
      class="mt-3 bg-[#efefef] rounded-[100px] inline-flex justify-start items-center"
    >
      <ng-template pTemplate="separator">
        <span>
          <mat-icon
            class="separator"
            [svgIcon]="'tabler-icon:small-right-chevron'"
          ></mat-icon
        ></span>
      </ng-template>
    </p-breadcrumb>
    @if (true) {
      <router-outlet
        (activate)="setBreadcrumb()"
        style="margin-top: 56px"
      ></router-outlet>
    }
  </div>

  <!-- Footer-->
  <div
    id="tv-footer"
    class="bg-card mt-10 flex w-full flex-col items-center justify-center gap-3 py-6"
    [ngClass]="getPaddingClass()"
  >
    <div class="flex items-center justify-between self-stretch">
      <div class="flex items-center gap-8">
        <div class="text-center text-sm font-medium text-primary">
          <a [routerLink]="['']"> {{ "project.tabTitle.home" | transloco }}</a>
        </div>
        <div class="text-center text-sm font-medium text-primary">
          <a [routerLink]="['/information/support/contact']">
            {{ "footer.linkTitle35" | transloco }}</a
          >
        </div>
        <div class="text-center text-sm font-medium text-primary">
          <a
            [href]="partnerPortalUrl"
            target="_blank"
            rel="noopener noreferrer"
          >
            Partner Portal
          </a>
        </div>
        <!-- <div class="text-center text-sm font-medium text-primary">
          <a [routerLink]="['/information/support/contact']"> Support</a>
        </div> -->
      </div>
      <div class="flex items-center gap-8">
        <div class="h-4 w-4">
          <a href="https://www.linkedin.com/company/tesvolt" target="_blank"
            ><mat-icon
              svgIcon="custom_icon:linked-in"
              class="hover:text-primary"
            ></mat-icon
          ></a>
        </div>
        <div class="h-4 w-4">
          <a href="mailto:portal.support@tesvolt.com"
            ><mat-icon
              svgIcon="custom_icon:email"
              class="hover:text-primary"
            ></mat-icon
          ></a>
        </div>
        <div class="h-4 w-4">
          <a href="tel:+4934918797100"
            ><mat-icon
              svgIcon="custom_icon:phone"
              class="hover:text-primary icon-size-5"
            ></mat-icon
          ></a>
        </div>
      </div>
    </div>
    <div class="w-full border-t border-gray-300"></div>
    <!-- Copyright and Links -->
    <div class="inline-flex items-center justify-between self-stretch">
      <div class="flex items-center justify-start gap-7">
        <label class="text-gray text-sm font-normal"
          >© {{ currentYear }} TESVOLT AG
        </label>
        <a
          class="text-gray text-sm font-normal hover:text-primary no-underline"
          target="_blank"
          [href]="
            getLocalizedLink('https://www.tesvolt.com/{lang}/datenschutz.html')
          "
          >{{ "marketingForm.acknowledgement3" | transloco }}
        </a>
        <a
          class="text-gray text-sm font-normal hover:text-primary no-underline"
          target="_blank"
          [href]="
            getLocalizedLink('https://www.tesvolt.com/{lang}/impressum.html')
          "
          >{{ "footer.legalLink1" | transloco }}</a
        >
      </div>
      <div class="flex items-center justify-start gap-[29px]">
        <a
          [routerLink]="'/portal-settings/version-history-view'"
          class="text-gray text-[0.875rem] font-normal leading-[0.875rem]"
        >
          Version: {{ version }}
        </a>
      </div>
    </div>
  </div>
</div>
